import { StatusType } from '../components/various/Status';
import { STATUS_COLORS } from '../constants/status';

export const getOrderStatusColor = (status?: StatusType) => {
  switch (status) {
    case 'checkoutCompleted':
      return STATUS_COLORS.SUCCESS;
    case 'completed':
      return STATUS_COLORS.SUCCESS;
    case 'inProgress':
      return STATUS_COLORS.WARNING;
    case 'checkoutRequested':
      return STATUS_COLORS.WARNING;
    case 'cancelled':
      return STATUS_COLORS.ERROR;
    default:
      return undefined;
  }
};

export const getInvoiceStatusColor = (status?: StatusType) => {
  switch (status) {
    case 'notPaid':
      return STATUS_COLORS.WARNING;
    case 'paid':
      return STATUS_COLORS.SUCCESS;
    case 'overdue':
      return STATUS_COLORS.ERROR;
    default:
      return undefined;
  }
};

export const getAccountRequestsStatusColor = (status: 0 | 1 | 2 | 3) => {
  switch (status) {
    case 0:
      return STATUS_COLORS.INFO;
    case 1:
      return STATUS_COLORS.SUCCESS;
    case 2:
      return STATUS_COLORS.ERROR;
    default:
      return undefined;
  }
};
